import axiosGlobal from "../../../axios-global";
import { history } from "../../../history";
import { config } from "../../../configs/firebaseConfig";
import firebase from "firebase/app";

import "firebase/auth";
import "firebase/database";

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let firebaseAuth = firebase.auth();
// const axios = axiosGlobal();

export const changeStatus = (login, register) => {
  return (dispatch) =>
    dispatch({ type: "CHANGE_STATUS", isLogin: login, isRegister: register });
};

export const setToken = (token) => {
  return (dispatch) => dispatch({ type: "SET_TOKEN", token: token });
};

export const setEmail = (email) => {
  return (dispatch) => dispatch({ type: "SET_EMAIL", email: email });
};

export const loginWithJWT = async (email, password) => {
  return (dispatch) => {
    const params = {
      email: email,
      password: password,
    };
    axiosGlobal().then((axios) => {
      axios
        .post("/login/junior", params)
        .then((response) => {
          if (response.data.data.authStatus === true) {
            dispatch({ type: "CHANGE_STATUS", isLogin: true });
          } else {
            dispatch({
              type: "LOGIN_WITH_JWT",
              payload: { error: true },
            });
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    });
  };
};

export const loginWithGoogle = () => {
  return (dispatch) => {
    let provider = new firebase.auth.GoogleAuthProvider();
    firebaseAuth
      .signInWithPopup(provider)
      .then(function (result) {
        let token = result.credential.accessToken,
          email = result.user.email;

        dispatch({ type: "CHANGE_STATUS", isLogin: true });
        dispatch({ type: "SET_EMAIL", email: email });
        dispatch({ type: "SET_TOKEN", token: token });
        history.push("/ecommerce/register");
        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const loginGoogle = () => {
  return async (dispatch) => {
    let provider = new firebase.auth.GoogleAuthProvider();
    firebaseAuth
      .signInWithPopup(provider)
      .then((result) => {
        let token = result.credential.accessToken,
          email = result.user.email;

        axiosGlobal().then((axios) => {
          axios
            .post("/emailAuth/junior", { email })
            .then((result) => {
              if (result.data.data.authStatus === true) {
                dispatch({ type: "CHANGE_STATUS", isLogin: true });
                dispatch({ type: "SET_EMAIL", email: email });
                dispatch({ type: "SET_TOKEN", token: result.data.data.token });
                history.push("/ecommerce/home");
                window.location.reload();
              }
            })
            .catch((err) => {
              // should handle when trying to push
              if (err.response.status === 403) {
                if (err.response.data.message === "Email Invalid") {
                  if (err.response.data.data.authStatus === false) {
                    dispatch({ type: "CHANGE_STATUS", isRegister: true });
                    dispatch({ type: "SET_EMAIL", email: email });
                    // dispatch({ type: "SET_TOKEN", token: token });
                    history.push("/ecommerce/register");
                    window.location.reload();
                  }
                }
              }
            });
        });
      })
      .catch(function (error) {
        // should handle error when login with fasebook
        console.log(error);
      });
  };
};
